<div class="sip-login-container">
  <div class="login-card">
    <div class="header-section">
      <div class="icon-logo-section">
        <div class="call-center-icon">
          <ion-icon name="dp-callcenter"></ion-icon>
        </div>
        <div class="logo">
          <img src="assets/images/logo.svg" alt="Mallorcab Logo" />
        </div>
      </div>
      <h1 class="heading">{{ heading }}</h1>
    </div>

    <div class="stats-section">
      <div class="stat-card" *ngFor="let stat of statistics" [class.available]="stat.isAvailable">
        <div class="stat-number">{{ stat.number }}</div>
        <div class="stat-label">{{ stat.label }}</div>
      </div>
    </div>

    <div class="button-section">
      <button class="login-button" (click)="onLoginClick()">
        <ion-icon name="fire"></ion-icon>
        <span>{{ buttonText }}</span>
        <ion-icon name="arrow-forward"></ion-icon>
      </button>
    </div>
  </div>
</div>